import { render, staticRenderFns } from "./TeacherAssessmentReport.vue?vue&type=template&id=4be8ffff&scoped=true"
import script from "./TeacherAssessmentReport.vue?vue&type=script&lang=js"
export * from "./TeacherAssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./TeacherAssessmentReport.vue?vue&type=style&index=0&id=4be8ffff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be8ffff",
  null
  
)

export default component.exports